module.exports = __webpack_public_path__ + "static/media/mountainsBG.7c45097e.jpg";